export default __webpack_public_path__ + "static/media/bankid-main_140x21.f248e7a0.svg";